"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MailAccountConfig = class MailAccountConfig extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    recipient;
    async $$load_recipient() {
        return this.$app.auth.user.email;
    }
    sendMailTestResult;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    sendTestEmailFormId;
    async $$load_sendTestEmailFormId() {
        return this.$fn.randomElementId();
    }
    formName;
    sendTestEmailFormName;
    config;
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('get_object_by_type', { parameters: { id: this.oid, object_type: 'mail-account' }, asResource: true })
            : new this.$fn.Resource(_.reduce(this.$data.config, (m, v, k) => _.set(m, k, _.get(v, 'default', null))));
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    change_password;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['recipient', 'sendMailTestResult', 'formId', 'sendTestEmailFormId', 'formName', 'sendTestEmailFormName', 'config', 'resource', 'editor', 'change_password', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                recipient: null,
                sendMailTestResult: null,
                formId: null,
                sendTestEmailFormId: null,
                formName: "MailAccountConfig",
                sendTestEmailFormName: "SendTestEmail",
                config: {
                    tls: {
                        label: this.$fn.pgettext("MailAccount", "Use TLS"),
                        help: this.$fn.pgettext("MailAccount", "Enable TLS encryption for the connection."),
                        default: true,
                    },
                    ssl: {
                        label: this.$fn.pgettext("MailAccount", "SSL"),
                        help: this.$fn.pgettext("MailAccount", "Use SSL to secure the connection."),
                        default: true,
                    },
                    use_credentials: {
                        label: this.$fn.pgettext("MailAccount", "Use Credentials"),
                        help: this.$fn.pgettext("MailAccount", "Require username and password to authenticate."),
                        default: true,
                    },
                    validate_certs: {
                        label: this.$fn.pgettext("MailAccount", "Validate Certificates"),
                        help: this.$fn.pgettext("MailAccount", "Check that server certificates are valid."),
                        default: true,
                    },
                    mail_from_name: {
                        label: this.$fn.pgettext("MailAccount", "Mail From Name"),
                        help: this.$fn.pgettext("MailAccount", "Name displayed as the sender of the email."),
                    },
                    server: {
                        label: this.$fn.pgettext("MailAccount", "Server"),
                        help: this.$fn.pgettext("MailAccount", "Address of the mail server."),
                        default: "smtp.server.com",
                    },
                    port: {
                        label: this.$fn.pgettext("MailAccount", "Port"),
                        help: this.$fn.pgettext("MailAccount", "Port number for the mail server connection."),
                        default: 587,
                    },
                    debug: {
                        label: this.$fn.pgettext("MailAccount", "Debug"),
                        help: this.$fn.pgettext("MailAccount", "Show detailed connection and sending logs."),
                        default: false,
                    },
                    username: {
                        label: this.$fn.pgettext("MailAccount", "Username"),
                        help: this.$fn.pgettext("MailAccount", "Your login name for authentication."),
                    },
                    password: {
                        label: this.$fn.pgettext("MailAccount", "Password"),
                        help: this.$fn.pgettext("MailAccount", "Your account password."),
                    },
                    confirm_password: {
                        label: this.$fn.pgettext("MailAccount", "Confirm Password"),
                        help: this.$fn.pgettext("MailAccount", "Re-enter password to verify."),
                    },
                    timeout: {
                        label: this.$fn.pgettext("MailAccount", "Timeout"),
                        help: this.$fn.pgettext("MailAccount", "Time to wait before giving up."),
                        default: 60,
                    },
                    description: {
                        label: this.$fn.pgettext("MailAccount", "Description"),
                        help: this.$fn.pgettext("MailAccount", "Short note or label for this entry."),
                    },
                    address: {
                        label: this.$fn.pgettext("MailAccount", "Address"),
                        help: this.$fn.pgettext("MailAccount", "Email or server address to use."),
                        default: "username@provider.com",
                    },
                },
                resource: null,
                editor: null,
                change_password: {
                    password: null,
                    confirm_password: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("MailAccountConfig|Title", "Mail account configuration"),
                ],
                icon: this.$config.settings.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5420_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_5426_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_5424_getActionArgs($event) {
        return {
            objectType: "object_by_type",
            op: "upsert",
            data: {
                ...this.editor.getData(),
                'object_type': 'mail-account',
                ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {})
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_closeModal_5430_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_4186377094414664_crud_5428_getActionArgs($event) {
        return {
            objectType: "object_by_type",
            op: "upsert",
            data: {
                ...this.editor.getData(),
                'object_type': 'mail-account',
                ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {})
            },
        };
    }
    async evh_4186377094414664_submit(event, scope) {
        return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
    }
    async act_4699325371235600_setData_5432_getActionArgs($event) {
        return {
            path: "sendMailTestResult",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4699325371235600_script_5436_getActionArgs_value($event) {
        this.sendMailTestResult = 'success';
    }
    async act_4699325371235600_script_5436_getActionArgs($event) {
        return {
            value: () => this.act_4699325371235600_script_5436_getActionArgs_value($event),
        };
    }
    async act_4699325371235600_request_5434_getActionArgs($event) {
        return {
            operation: "post_sendmail_test",
            data: { mail_account: this.resource.id, recipient: this.recipient },
        };
    }
    async evh_4699325371235600_clickPreventStop(event, scope) {
        return await this.actions.evh_4699325371235600_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_5440_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_5438_getActionArgs($event) {
        return {
            operation: "delete_object_by_type",
            data: this.resource.getData({ fields: ['id', 'etag'] }),
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_5442_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5420 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5420_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5419 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5420,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5419],
        });
        const act_2248226175642056_closeComponent_5422 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5421 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5422,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5421],
        });
        const act_1040167445267876_closeModal_5426 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_5426_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5425 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_5426,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_5424 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_5424_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_5425],
        });
        const evh_1040167445267876_submit_5423 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_5424,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5423],
        });
        const act_4186377094414664_closeModal_5430 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_4186377094414664_closeModal_5430_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_success_5429 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_closeModal_5430,
            event: "success",
            displayName: "closeModal",
        });
        const act_4186377094414664_crud_5428 = new core_1.actions.CRUDAction({
            actionArgs: this.act_4186377094414664_crud_5428_getActionArgs,
            displayName: "save",
            events: [evh_4186377094414664_success_5429],
        });
        const evh_4186377094414664_submit_5427 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_crud_5428,
            event: "submit",
            displayName: "save",
        });
        const evh_4186377094414664_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_submit_5427],
        });
        const act_4699325371235600_setData_5432 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4699325371235600_setData_5432_getActionArgs,
            events: [],
        });
        const evh_4699325371235600_clickPreventStop_5431 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_setData_5432,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const act_4699325371235600_script_5436 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4699325371235600_script_5436_getActionArgs,
            events: [],
        });
        const evh_4699325371235600_success_5435 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_script_5436,
            event: "success",
            displayName: "script",
        });
        const act_4699325371235600_request_5434 = new core_1.actions.RequestAction({
            actionArgs: this.act_4699325371235600_request_5434_getActionArgs,
            displayName: "sendTestEmail",
            events: [evh_4699325371235600_success_5435],
        });
        const evh_4699325371235600_clickPreventStop_5433 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_request_5434,
            event: "click.prevent.stop",
            displayName: "sendTestEmail",
        });
        const evh_4699325371235600_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4699325371235600_clickPreventStop_5431, evh_4699325371235600_clickPreventStop_5433],
        });
        const act_1548630417156826_closeModal_5440 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_5440_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_5439 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_5440,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_5438 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_5438_getActionArgs,
            displayName: "delete",
            events: [evh_1548630417156826_success_5439],
        });
        const evh_1548630417156826_clickPreventStop_5437 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_5438,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_5437],
        });
        const act_2186679009640457_closeModal_5442 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_5442_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_5441 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_5442,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_5441],
        });
        return {
            act_7315092382398562_closeModal_5420,
            evh_7315092382398562_close_5419,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5422,
            evh_2248226175642056_close_5421,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_5426,
            evh_1040167445267876_success_5425,
            act_1040167445267876_crud_5424,
            evh_1040167445267876_submit_5423,
            evh_1040167445267876_submit,
            act_4186377094414664_closeModal_5430,
            evh_4186377094414664_success_5429,
            act_4186377094414664_crud_5428,
            evh_4186377094414664_submit_5427,
            evh_4186377094414664_submit,
            act_4699325371235600_setData_5432,
            evh_4699325371235600_clickPreventStop_5431,
            act_4699325371235600_script_5436,
            evh_4699325371235600_success_5435,
            act_4699325371235600_request_5434,
            evh_4699325371235600_clickPreventStop_5433,
            evh_4699325371235600_clickPreventStop,
            act_1548630417156826_closeModal_5440,
            evh_1548630417156826_success_5439,
            act_1548630417156826_request_5438,
            evh_1548630417156826_clickPreventStop_5437,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeModal_5442,
            evh_2186679009640457_clickPreventStop_5441,
            evh_2186679009640457_clickPreventStop,
            save: act_4186377094414664_crud_5428,
            sendTestEmail: act_4699325371235600_request_5434,
            delete: act_1548630417156826_request_5438,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], MailAccountConfig.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MailAccountConfig.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], MailAccountConfig.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MailAccountConfig.prototype, "onSize", null);
MailAccountConfig = __decorate([
    (0, vue_property_decorator_1.Component)()
], MailAccountConfig);
exports.default = MailAccountConfig;
vue_property_decorator_1.Vue.component("MailAccountConfig", MailAccountConfig);
